<template>
  <b-card
    class="cardStyle"
    style="height: 100%;font-weight: 400;font-size: 16px;line-height: 20px;"
  >
    <div>
      Need More Help?
    </div>
    <hr class="solid" />
    <div class="text-primary">
      <b-icon icon="envelope-fill" scale="1"></b-icon>&nbsp;&nbsp;
      <a :href="`mailto:${supportMail}`">{{ supportMail }}</a>
    </div>
    <div class="text-primary mt-2">
      <b-icon icon="telephone-fill" scale="1"></b-icon>&nbsp;&nbsp;<a :href="'tel:' + tel"
        >+{{ tel }}</a
      >
    </div>
  </b-card>
</template>

<script>
  export default {
    data() {
      return {
        supportMail: 'support.pfizer@pfizer.com',
        tel: '012127737746',
      };
    },
  };
</script>
